define("shared/utils/crop-array", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.canonicalizeCropArray = canonicalizeCropArray;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Normalizes a [x1, y1, x2, y2] crop array so x1 < x2 and y1 < y2.
   * Returns the input unchanged when it is empty or not exactly four coordinates.
   */
  function canonicalizeCropArray(cropArray) {
    if (cropArray.length !== 4) {
      return cropArray;
    }
    const [x1, y1, x2, y2] = cropArray;
    return [Math.min(x1, x2), Math.min(y1, y2), Math.max(x1, x2), Math.max(y1, y2)];
  }
});